import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/material';
import { motion, useAnimation } from 'framer-motion';
import React, { useRef, useState, useEffect } from 'react';
import { WIDGET_MEDIA_BORDER_RADIUS } from '../../utils/constants/Constants.js';
import { useStateWithDep } from '../../utils/hooks/useStateWithDep.js';

var VideoContainer = styled(motion.div)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    maxHeight: 'inherit',
    width: '100%',
    height: '100%',
    '.video_control': {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
        width: '100%',
        height: '100%',
        '&.lower': {
            alignItems: 'flex-end',
            justifyContent: 'flex-start',
            padding: '20px',
            '.control_button': {
                width: '25%',
            },
        },
        cursor: 'pointer',
        '.control_button': {
            background: 'none',
            outline: 'none',
            border: 'none',
            opacity: 0,
            transition: 'opacity 500ms',
            width: '23%',
            maxWidth: 100,
            cursor: 'pointer',
            '.play_button': {
                height: '100%',
                width: '100%',
            },
            '.pause_button': {
                height: '100%',
                width: '100%',
            },
        },
        '&.playing': {
            '.control_button': {
                opacity: '0 !important',
            },
        },
        '&.paused': {
            '.control_button': {
                opacity: '1 !important',
            },
        },
    },
    '.video_content': {
        objectFit: 'contain',
        borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
        maxHeight: '100%',
        maxWidth: '100%',
    },
    'video[poster]': {
        maxHeight: '100%',
        maxWidth: '100%',
        width: '100%',
        height: '100%',
    },
});
var BrandclubVideo = function (_a) {
    var _b = _a.fixContainer, fixContainer = _b === void 0 ? false : _b, videoUrl = _a.videoUrl, posterUrl = _a.posterUrl, _c = _a.canPlay, canPlay = _c === void 0 ? true : _c, _d = _a.lowerPlaybutton, lowerPlaybutton = _d === void 0 ? false : _d, _e = _a.onPlay, onPlay = _e === void 0 ? function () { return ({}); } : _e, _f = _a.onPause, onPause = _f === void 0 ? function () { return ({}); } : _f, _g = _a.onEnd, onEnd = _g === void 0 ? function () { return ({}); } : _g;
    var videoRef = useRef(null);
    var _h = useState(false), playing = _h[0], setPlaying = _h[1];
    var _j = useState(''), videoLink = _j[0], setVideoLink = _j[1];
    var _k = useStateWithDep(posterUrl), posterLink = _k[0], setPosterLink = _k[1];
    useEffect(function () {
        if (!canPlay) {
            pauseVideo();
        }
    }, [canPlay]);
    var controls = useAnimation();
    useEffect(function () {
        pauseVideo();
        videoSwitchAnimation();
    }, [videoUrl]);
    var videoSwitchAnimation = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(canPlay && videoLink)) return [3 /*break*/, 3];
                    return [4 /*yield*/, controls.start({
                            opacity: 1,
                            y: 0,
                            transition: { duration: 0 },
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, controls.start({
                            opacity: 0,
                            y: -10,
                            transition: { duration: 0.3 },
                        })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    setVideoLink(videoUrl);
                    setPosterLink(posterUrl);
                    if (!canPlay) return [3 /*break*/, 6];
                    return [4 /*yield*/, controls.start({
                            opacity: 0,
                            y: 10,
                            transition: { duration: 0 },
                        })];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, controls.start({
                            opacity: 1,
                            y: 0,
                            transition: { duration: 0.3 },
                        })];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var playVideo = function () {
        var _a;
        (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        setPlaying(true);
    };
    var pauseVideo = function () {
        var _a;
        (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        setPlaying(false);
    };
    var handleEnd = function () {
        var _a;
        (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.load();
        setPlaying(false);
    };
    return (React.createElement(VideoContainer, { className: "brandclub_video", animate: controls },
        React.createElement("div", { className: "video_control ".concat(playing ? 'playing' : 'paused', " ").concat(lowerPlaybutton ? 'lower' : ''), onClick: function () {
                if (canPlay) {
                    if (!playing) {
                        playVideo();
                    }
                    else {
                        pauseVideo();
                    }
                }
            } }, canPlay ? (!playing ? (React.createElement("button", { className: "control_button play " },
            React.createElement("img", { loading: "lazy", className: 'play_button', src: 'https://media.brandclub.com/brandclub/image_asset/video_play.svg', alt: 'play' }))) : (React.createElement("button", { className: "control_button pause" },
            React.createElement("img", { loading: "lazy", className: "pause_button", src: 'https://media.brandclub.com/brandclub/image_asset/video_pause.svg', alt: "pause" })))) : null),
        React.createElement("video", { ref: videoRef, src: videoLink, playsInline: true, controls: false, style: { background: 'white', display: 'block', position: fixContainer ? 'absolute' : 'relative' }, className: "video_content", poster: posterLink, onPlay: onPlay, onPause: function (event) {
                if (!playing) {
                    onPause({ currentTime: event.currentTarget.currentTime });
                }
            }, onEnded: function (event) {
                onEnd({ duration: event.currentTarget.duration });
                handleEnd();
            } })));
};

export { BrandclubVideo };
//# sourceMappingURL=BrandclubVideo.js.map
